export const ACTIONS = {
  VIEW: 'VIEW'
}

export const SUBJECTS = {
  BANKING_SETUP_HS_DETAILS: 'Banking Setup HS Details',
  BANKING_SETUP_HOSPITAL_DETAILS: 'Banking Setup Hospital Details',
  BANK_ACCOUNTS_HOSPITAL_DETAILS: 'Bank Accounts Hospital Details',
  BANK_ACCOUNTS_HS_DETAILS: 'Bank Accounts HS Details'
}
